<template>
  <div id="data-list-list-view" class="data-list-container">

    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <vx-card collapse="false" ref="filterCard" title="Filtros" class="user-list-filters mb-8" collapse-action
             refresh-content-action @refresh="resetFilters">
      <h5 class="mt-5 mb-2">Filtrar por fecha</h5>
      <div class="vx-row">
        <div class="vx-col md:w-1/2">
          <datepicker :language="es" label="Desde" v-model="startDate" id="startDate"
                      v-validate="'required'" name="startDate"></datepicker>
        </div>
        <div class="vx-col md:w-1/2">
          <datepicker :language="es" label="Hasta" v-model="endDate" id="endDate"
                      v-validate="'required'" name="startDate"></datepicker>
        </div>
        <div class="vx-col mt-2">
          <vs-button @click="filterByDate" class="mr-6 vs-align-right">Filtrar</vs-button>
        </div>
      </div>
    </vx-card>

    <new :vehicles="vehicles" :requests="requests" :warehouses="warehouses" :merchants="merchants" :products="products"
         @add="addDataSideBar"
         :isSidebarActive="newSidebar"
         @closeSidebar="newSidebar= false"/>

    <detail :data="sidebarData" :isSidebarActive="detailSidebar" @closeSidebar="detailSidebar= false"/>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="list">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- Action - dropnow -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
                class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="sidebarData= selected, detailSidebar= true">
                            <span class="flex items-center">
                              <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-2"/>
                              <span>Ver detalle</span>
                            </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="openUrl(selected.nubefact.enlace_del_pdf)">
                            <span class="flex items-center">
                              <feather-icon icon="ExternalLinkIcon" svgClasses="h-4 w-4" class="mr-2"/>
                              <span>Ver PDF</span>
                            </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- Add new -->
          <div
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="newSidebar= true">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary">Agregar</span>
          </div>
        </div>
        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ list.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : list.length }} de {{
                queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Nro. Doc</vs-th>
        <vs-th>Fecha de traslado</vs-th>
        <vs-th sort-key="motive">Motivo</vs-th>
        <vs-th sort-key="user">Usuario</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.serial + '-' + tr.sequence }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.createdAt | date(true) }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.motive }}</p>
          </vs-td>

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.user.displayName }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon class="mr-2" title="Detalle" icon="EyeIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="sidebarData= tr, detailSidebar= true"/>
            <feather-icon title="Ver PDF" icon="ExternalLinkIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="openUrl(tr.nubefact.enlace_del_pdf)"/>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import New from './New'
import Detail from './Detail'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'

import { db, Timestamp } from '@/firebase/firebaseConfig'

export default {
  components: {
    New,
    Detail,
    Datepicker
  },
  data () {
    return {
      selected: null,
      itemsPerPage: 10,
      isMounted: false,
      list: [],
      merchants: [],
      warehouses: [],
      products: [],
      requests: [],
      vehicles: [],
      initProgress: false,

      // Data Sidebar
      newSidebar: false,
      detailSidebar: false,
      sidebarData: {},

      //Filters
      startDate: null,
      endDate: null,
      es: es,

      // Date
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      },
    }
  },
  async created () {
    try {
      //Get transfers
      this.initProgress = true
      await this.loadTransfers()
      await this.loadProducts()
      await this.loadWarehouses()
      await this.loadVehicles()
      // Set filter las 30 days
      this.startDate = new Date(new Date().setDate(new Date().getDate() - 30))
      this.endDate = new Date()
    } catch (e) {
      console.log(e)
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    } finally {
      this.initProgress = false
    }
  },
  mounted () {
    this.isMounted = true
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.list.length
    }
  },
  methods: {
    /**
     * Add data of sidebar
     * */
    addDataSideBar (o) {
      this.list.unshift(o)
    },
    /**
     * Update data of sidebar
     * */
    updateDataSideBar (o) {
      const index = this.list.findIndex((d) => d.id === o.id)
      Object.assign(this.list[index], o)
    },
    /**
     * Get transfers of firestore
     * @returns {Promise<void>}
     */
    async loadTransfers () {
      const querySnapshot = await db.collection('transfers').orderBy('createdAt', 'desc').limit(100).get()
      querySnapshot.forEach((doc) => {
        let obj = {
          id: doc.id,
          ...doc.data(),
          sequence: doc.data().sequence || '',
          serial: doc.data().serial || ''
        }
        obj.createdAt = doc.data().createdAt.toDate()
        this.list.push(obj)
      })
    },
    /**
     * Get warehouses of firestore
     * @returns {Promise<void>}
     */
    async loadWarehouses () {
      this.warehouses = []
      const querySnapshot = await db.collection('warehouses').where('state', '==', true).orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let warehouse = {
          id: doc.id,
          name: doc.data().name,
          address: doc.data().address,
          ruc: doc.data().ruc,
          department: doc.data().department,
          province: doc.data().province,
          district: doc.data().district,
          ubigeo: doc.data().ubigeo
        }
        this.warehouses.push(warehouse)
      })
    },
    /**
     * Get products of firestore
     * @returns {Promise<void>}
     */
    async loadProducts () {
      this.products = []
      const querySnapshot = await db.collection('products').where('state', '==', true).orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let product = {
          id: doc.id,
          description: doc.data().description,
          sku: doc.id.substr(0, 6).toUpperCase(),
          numberPart: doc.data().numberPart,
          label: doc.data().numberPart + ' - ' + doc.id.substr(0, 6).toUpperCase(),
          stock: doc.data().stock,
          cost: doc.data().price
        }
        this.products.push(product)
      })
    },
    /**
     * Get vehicles of firestore
     */
    async loadVehicles () {
      const querySnapshot = await db.collection('vehicles').where('state', '==', true).orderBy('createdAt', 'desc').get()
      querySnapshot.forEach((doc) => {
        let vehicle = {
          id: doc.id,
          ...doc.data()
        }
        this.vehicles.push(vehicle)
      })
    },
    /**
     * Reset filters of firestore
     * @returns {Promise<void>}
     */
    async resetFilters () {
      this.initProgress = true
      this.list = []
      this.startDate = null
      this.endDate = null
      await this.loadTransfers()
      this.$refs.filterCard.removeRefreshAnimation()
      this.initProgress = false
    },
    /**
     * Filter by date
     */
    async filterByDate () {
      try {
        this.initProgress = true
        this.list = []
        // Set start date
        this.startDate.setHours(0)
        this.startDate.setMinutes(0)
        // Set end date
        this.endDate.setHours(23)
        this.endDate.setMinutes(59)

        this.startDate.set
        const starTimes = Timestamp.fromDate(this.startDate)
        const endTimes = Timestamp.fromDate(this.endDate)
        const querySnapshot = await db.collection('transfers')
            .where('createdAt', '>=', starTimes)
            .where('createdAt', '<=', endTimes).get()
        querySnapshot.forEach((doc) => {
          this.list.push({
            id: doc.id,
            ...doc.data(),
            createdAt: doc.data().createdAt.toDate()
          })
        })
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      } finally {
        this.initProgress = false
      }
    },
    // Open URL
    openUrl (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
